import { AccountGroupDropdownData, UsersSearchDropdownData } from "../../../../Utils/AllPagesQuriesAndMutations";

export const data = [
  {
    name: "VerticalSection",
    section: "VendorAccount",
    ValidationName: "VerticalSection1",
    sections: [
      {
        name: "Business_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Business_Name",
            label: "Name",
            type: "text",
            FirstCharCap: true,
            isRequired: true,
            autoFocus: true,
          },
          {
            id: Math.random() * 10,
            name: "Business_Address",
            label: "Business Address",
            type: "textarea",
            FirstCharCap: true,
          },
          {
            id: Math.random() * 10,
            name: "Business_Pincode",
            label: "Pincode",
            type: "number",
            min: 6,
            max: 6,
            // ValidationType: "PINCODE",
            ValidationType: "VALID_NUMBER",
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Business_City",
                label: "City",
                setvalue: "City",
                disable: true,
                FirstCharCap: true,
                type: "InputDropForQuery",
                masterName: "City_Master",
              },
              {
                id: Math.random() * 10,
                name: "Business_State",
                label: "State",
                disable: true,
                setvalue: "State",
                FirstCharCap: true,
                type: "InputDropForQuery",
                masterName: "State_Master",
              },
            ],
          },

          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Business_Mobile_Number",
                label: "Mobile No",
                type: "number",
                // isRequired: true,
                min: 10,
                max: 10,
                ValidationType: "VALID_NUMBER",
              },
              {
                id: Math.random() * 10,
                name: "Land_Line",
                label: "Land Line",
                type: "number",
                min: 11,
                max: 11,
              },
            ],
          },
          {
            id: Math.random() * 10,
            name: "Business_Mobile_Number_Two",
            label: "Alternate Mobile No 1",
            type: "number",
            min: 6,
            max: 11,
            ValidationType: "VALID_NUMBER",
          },
          {
            id: Math.random() * 10,
            name: "Business_Mobile_Number_Three",
            label: "Alternate Mobile No 2",
            type: "number",
            min: 6,
            max: 11,
            ValidationType: "VALID_NUMBER",
          },
          {
            id: Math.random() * 10,
            name: "Email",
            label: "Email",
            type: "text",
            ValidationType: "EMAIL",
          },
          {
            id: Math.random() * 10,
            name: "GST_Number",
            label: "GST Number",
            type: "text",
            min: 15,
            max: 15,
            AllCaps: true,
            ValidationType: "GST",
          },
          {
            id: Math.random() * 10,
            name: "Business_Pan",
            label: "Business PAN ",
            type: "text",
            min: 10,
            max: 10,
            AllCaps: true,
            ValidationType: "PAN",
          },
          {
            id: Math.random() * 10,
            name: "Account_Manager",
            label: "Account Manager ",
            masterName: "User_Entry",
            type: "InputDropForQuery",
            dropdowndata: UsersSearchDropdownData,
          },
        ],
      },
      {
        name: "Account_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "IFSC_Code",
            label: "IFSC Code",
            type: "text",
            min: 11,
            max: 11,
            AllCaps: true,
            ValidationType: "IFSC",
          },
          {
            id: Math.random() * 10,
            name: "Account_Number",
            label: "Account Number",
            type: "text",
            min: 9,
            max: 27,
            ValidationType: "VALID_NUMBER",
          },
        ],
      },
    ],
  },
  {
    name: "VerticalSection",
    VerticalSection: true,
    ValidationName: "VerticalSection2",
    sections: [
      {
        name: "Personal_Details",
        fields: [
          {
            id: Math.random() * 10,
            name: "Proprietor_Name",
            label: "Name (As Per Adhar)",
            type: "text",
            FirstCharCap: true,

            ValidationType: "VALID_STRING",
          },
          {
            id: Math.random() * 10,
            name: "Residential_Address",
            label: "Residential Address",
            type: "textarea",
            FirstCharCap: true,
          },
          {
            id: Math.random() * 10,
            name: "Residential_Pincode",
            type: "number",
            min: 6,
            max: 6,
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Residential_City",
                label: "City",
                setvalue: "City",
                disable: true,
                type: "InputDropForQuery",
                masterName: "City_Master",
                FirstCharCap: true,
              },
              {
                id: Math.random() * 10,
                name: "Residential_State",
                label: "State",
                setvalue: "State",
                disable: true,
                type: "InputDropForQuery",
                masterName: "State_Master",
                FirstCharCap: true,
              },
            ],
          },
          {
            id: Math.random() * 10,
            name: "Mobile_Number",
            label: "Mobile Number",
            type: "number",
            min: 10,
            max: 10,

            ValidationType: "VALID_STRING",
          },
          {
            id: Math.random() * 10,
            name: "Emergency_Mobile_Number",
            label: "Emergency Number",
            type: "number",
            min: 10,
            max: 10,
          },
          {
            id: Math.random() * 10,
            name: "Aadhar_Number",
            label: "Aadhar Number",
            type: "inputMask",
            mask: "9999-9999-9999",
            min: 12,
            max: 12,
            ValidationType: "AADHAAR",
          },
          {
            id: Math.random() * 10,
            name: "Pan_Number",
            label: "Pan Number",
            type: "text",
            min: 10,
            max: 10,
            AllCaps: true,
            ValidationType: "PAN",
          },
          {
            id: Math.random() * 10,
            name: "Account_Group",
            label: "Account Group ",
            masterName: "Account_Group",
            type: "InputDropForQuery",
            // QueryID: "658ad706da655f52d7648002",
            // dropdowndata: AccountGroupDropdownData,
          },
          {
            id: Math.random() * 10,
            name: "Reference",
            label: "Reference",
            type: "text",
            FirstCharCap: true,
          },
          {
            id: Math.random() * 10,
            name: "Description",
            label: "Narration",
            type: "textarea",
            FirstCharCap: true,
          },
        ],
      },
      {
        name: "Balance_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Balance_Method",
            label: "Balance_Method",
            type: "inputdrop",
            dropdowncontent: ["Balance Only", "Bill By Bill"],
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Opening_Balance",
                label: "Opening Balance",
                type: "number",
              },
              {
                id: Math.random() * 10,
                name: "Credit_Or_Debit",
                label: "Cr/Db",
                type: "inputdrop",
                dropdowncontent: ["Cr", "Db"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Transporter_Info",
    // VerticalSection: true,
    fields: [
      {
        id: Math.random() * 10,
        name: "Transporter_Type",
        label: "Broker/Fleetowner",
        type: "inputdrop",
        dropdowncontent: ["Fleet Owner", "Commission Agent", "Fleet Owner & Commission Agent"],
      },
      {
        id: Math.random() * 10,
        name: "Directory_NonDirectory",
        label: "Directory/NonDirectory",
        type: "inputdrop",
        dropdowncontent: ["Directory", "NonDirectory"],
      },
      {
        id: Math.random() * 10,
        name: "No_Of_Vehicle_Owned",
        label: "No Of Vehicles Owned",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Service_Type",
        label: "Service_Type",
        dropdowncontent: [
          "FTL (Full Truck Load)",
          "PTL (Part Truck Load)",
          "FCL (Full Container Load)",
          "LCL (Less Than Container Load)",
        ],
        type: "MultiSelect",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "MSME",
        label: "MSME",
        dropdowncontent: ["YES", "NO"],

        type: "inputdrop",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "MSME_NO",
        label: "MSME Number",
        dependOn: {
          section: "Transporter_Info",
          name: "MSME",
          visibleOn: "YES",
        },
        type: "text",
        min: 1,
        max: Infinity,
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Aadhar_Card",
        label: "Aadhar Card",
      },
      {
        id: Math.random() * 10,
        name: "Pan_Card",
        label: "Pan Card",
      },
      {
        id: Math.random() * 10,
        name: "Proprietor_Photo",
        label: "Proprietor Photo",
      },
      {
        id: Math.random() * 10,
        name: "Visiting_Card",
        label: "Visiting Card",
      },
      {
        id: Math.random() * 10,
        name: "GST_Certificate",
        label: "GST Certificate",
      },
      {
        id: Math.random() * 10,
        name: "Shop_Act_Licence",
        label: "Shop Act Licence",
      },
      {
        id: Math.random() * 10,
        name: "Cancelled_Cheque",
        label: "Cancelled Cheque",
      },
      {
        id: Math.random() * 10,
        name: "Office_Board_Photo",
        label: "Office Board Photo",
      },
      {
        id: Math.random() * 10,
        name: "MSME_certificate",
        label: "MSME certificate",
      },
      {
        id: Math.random() * 10,
        name: "Self_Declaration_video",
        label: "Self Declaration video",
      },
      {
        id: Math.random() * 10,
        name: "Other_Doc_1",
        label: "Other Doc 1",
      },
      {
        id: Math.random() * 10,
        name: "Other_Doc_2",
        label: "Other Doc 2",
      },
    ],
  },
  {
    name: "Controls",
    fields: [
      {
        id: Math.random() * 10,
        name: "Is_Lock",
        label: "Lock ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Verified",
        label: "Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disableDependOn: {
          section: "",
          disableOn: "",
          name: "Is_Verified",
          value: true,
        },
      },
      {
        id: Math.random() * 10,
        name: "Not_Intrested",
        label: "Not Intrested",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Document_Verified",
        label: "Document Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Mobile_Number_Verified",
        label: "Mobile No Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Email_Verified",
        label: "Email Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: false,
      },
      {
        id: Math.random() * 10,
        name: "Is_Aadhar_Verified",
        label: "Aadhar Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "KYC_Complete",
        label: "Kyc Complete",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Pan_Verified",
        label: "Pan Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Gst_Verified",
        label: "GST Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Bank_Verified",
        label: "Bank Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Reverse_Lanes",
      //   label: "Reverse Lanes ",
      //   type: "checkbox",
      //   min: 0,
      //   max: Infinity,
      //   disabled: false,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "CreateCSUser",
      //   label: "Create CS User",
      //   type: "checkbox",
      //   min: 0,
      //   max: Infinity,
      //   disabled: false,
      // },
    ],
  },
];

export const VendorRemarksData = {
  Is_Verified: {
    id: Math.random() * 10,
    name: "Verified_Remark",
    label: "Remarks",
    type: "Text Box(Multi Line)",
    FirstCharCap: true,
  },
  Not_Intrested: {
    id: Math.random() * 10,
    name: "Not_Intrested_Remark",
    label: "Not Intrested Remark",
    type: "Text Box(Multi Line)",
    FirstCharCap: true,
  },
};

export const NotInterestedRemarks = {};

export const controlData = [
  {
    name: "Controls",
    fields: [
      {
        id: Math.random() * 10,
        name: "Is_Lock",
        label: "Lock ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Verified",
        label: "Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disableDependOn: {
          section: "Controls",
          disableOn: "",
          name: "Is_Verified",
          // value: true,
          disableOnValue: true,
        },
      },
      {
        id: Math.random() * 10,
        name: "Not_Intrested",
        label: "Not Intrested",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Document_Verified",
        label: "Document Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Mobile_Number_Verified",
        label: "Mobile No Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Email_Verified",
        label: "Email Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: false,
      },
      {
        id: Math.random() * 10,
        name: "Is_Aadhar_Verified",
        label: "Aadhar Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "KYC_Complete",
        label: "Kyc Complete",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Pan_Verified",
        label: "Pan Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Gst_Verified",
        label: "GST Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Bank_Verified",
        label: "Bank Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Reverse_Lanes",
      //   label: "Reverse Lanes ",
      //   type: "checkbox",
      //   min: 0,
      //   max: Infinity,
      //   disabled: false,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "CreateCSUser",
      //   label: "Create CS User",
      //   type: "checkbox",
      //   min: 0,
      //   max: Infinity,
      //   disabled: false,
      // },
    ],
  },
];

export const DefaultConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "accountgroups",
        label: "Default Account Group ",
        masterName: "Account_Group",
        type: "InputDropForQuery",
      },
    ],
  },
];
